import styled from "styled-components";

export const BottomBtnDiv = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #333;
  background: #333;

  color: var(--lara-button-button-text-color, #fff);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px; /* 121.429% */

  margin: 0 20px;
  bottom: 24px;
  position: fixed;
  width: calc(100% - 40px);
`;

export const BottomFlexDiv = styled.div`
  display: flex;
  height: 52px;
  gap: 8px;
  align-self: stretch;

  margin: 0 20px;
  bottom: 24px;
  position: absolute;
  width: calc(100% - 40px);
`;

export const BottomFlexBtn = styled.div`
  display: flex;
  height: 52px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  align-self: stretch;

  border-radius: 6px;
  border: ${(props) => (props.color ? props.color : "#333333")};
  background: ${(props) => (props.color ? props.color : "#333333")};

  color: ${(props) => (props.color ? "#333333" : "var(--lara-button-button-text-color, #fff)")};
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 17px; /* 121.429% */

  width: calc(50% - 4px);
`;